export default function qbInit(queryComponents) {
  const obj = queryComponents.reduce((acc, cur) => {
    if (cur.default_value || cur.default_value === 0) {
      acc[cur.clientName] = cur.default_value;
    } else {
      if (cur.type === "select" || cur.type === "progSelect") {
        acc[cur.clientName] = [];
      } else {
        acc[cur.clientName] = "";
      }
    }
    return acc;
  }, {});

  return obj;
}
